import { ref, onMounted } from "vue"
import { useStore } from "vuex"

export default {
  name: "FeedbackStepOne",
  props: {
    title: {
      type: String,
      required: true,
    },
    actions: {
      type: String,
      required: true,
    },
    negativeFeedbackActionId: {
      type: String,
      required: false
    },
    callback: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const store = useStore()
    const options = ref([])

    onMounted(() => {
      if (props.actions) {
        options.value = JSON.parse(props.actions)
      }
    })

    const inputSelected = (e) => {
      const value = e.target.value.toLowerCase();

      if ((value === 'nej' || value === 'ved ikke') && props.negativeFeedbackActionId) {
        store.dispatch("chatPanel/openChatAndHandleActionId", props.negativeFeedbackActionId);
      }

      if (props.callback) {
        props.callback(e.target.value)
      }
    }

    return {
      inputSelected,
      options,
    }
  },
}
